import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { PDFReader } from 'reactjs-pdf-reader';
import printJS from 'print-js';

import { HomeNavbar } from '../../common/home-navbar';
import { CheckoutStore } from '../../stores/CheckoutStore';
import { ParamsHelper } from '../../helpers/ParamsHelper';
import { SecondaryButton } from '../../common/secondary-button';
import { Spinner } from '../../common/spinner';
import styles from './BillingDetail.css';

const IPropTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

class BillingDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
    this._loadInfoCheckout = this._loadInfoCheckout.bind(this);
    this._print = this.print.bind(this);
  }

  componentDidMount() {
    this._loadInfoCheckout();
  }

  async _loadInfoCheckout() {
    const { token } = ParamsHelper.parseQueryParams(this.props.location.search);
    if (token) {
      try {
        await CheckoutStore.getBillingPDF(encodeURIComponent(token));
      } catch (error) {
        this.setState({ error: 'No se ha encontrado la factura' });
      }
    } else {
      this.setState({ error: 'No existe el identificador de la factura' });
    }
  }

  print() {
    if (CheckoutStore.billingBase64) {
      console.log(this);
      printJS({
        printable: CheckoutStore.billingBase64,
        type: 'pdf',
        base64: true,
      });
    }
  }

  render() {
    return (
      <div className={styles.container}>
        <HomeNavbar />
        <div className={styles.container}>
          <h1 className={styles.title}>
            Detalles de la factura
          </h1>
          {
            CheckoutStore.creationLoading &&
            <Spinner className={styles.spinner} />
          }
          {
            !this.state.error && !CheckoutStore.getError && CheckoutStore.billingBase64 &&
            <div className={styles.containerPdf}>
              <SecondaryButton
                className={styles.printButton}
                onClick={this.print}
              >
                IMPRIMIR
              </SecondaryButton>
              <PDFReader
                data={atob(CheckoutStore.billingBase64)}
              />
            </div>
          }
          {
            this.state.error &&
            <p className={styles.error}>{String(this.state.error)}</p>
          }
          {
            CheckoutStore.getError &&
            <p className={styles.error}>{String(CheckoutStore.getError.message)}</p>
          }
        </div>
      </div>
    );
  }
}

BillingDetail.propTypes = IPropTypes;

const ObservedBillingDetail = observer(BillingDetail);

export { ObservedBillingDetail as BillingDetail };



// WEBPACK FOOTER //
// ./src/pages/billing-detail/BillingDetail.jsx